import { Component, OnInit, signal } from '@angular/core';
import { TracerService } from '../../services/tracer.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer implements OnInit {
  protected readonly version = signal<string | null>(null);
  protected readonly year = new Date().getFullYear();
  // environment.name is already the user-facing value the footer
  // shows: 'staging' / 'sandbox' / 'release' / 'prod' (master config
  // sets name: 'prod'). 'dev' surfaces only on local builds.
  protected readonly env = environment.name;

  constructor(private readonly tracer: TracerService) {}

  ngOnInit(): void {
    this.tracer.getVersion().subscribe({
      next: res => this.version.set(res.version),
      error: () => this.version.set(null),
    });
  }
}
